import { a as ThemeMode } from '../../hooks/useThemeMode/ThemeMode-DBlsP3Iq.js';

function isNotDarkTheme(style) {
  return ({
    theme
  }) => {
    if (!(theme !== null && theme !== void 0 && theme.version) || theme.version !== 4 || (theme === null || theme === void 0 ? void 0 : theme.themeMode) !== ThemeMode.DARK) {
      return [style];
    }
    return null;
  };
}

export { isNotDarkTheme as i };
//# sourceMappingURL=isNotDarkTheme-BpLwrzY3.js.map
